import React, { FC, MouseEvent, useState } from 'react';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import frHeartSvg from '@src/svgs/fr-heart.svg';
import { BookmarkTypeEnum, useRemoveBookmarkMutation, useSaveBookmarkMutation } from '@src/graphql/generated';
import { useAppDispatch } from '@src/redux';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { setErrorFlashMessage } from '@src/redux/actions/flashMessages';
import { trackEvent } from '@src/metrics';
import { removeBookmarkFromCache, addBookmarkToCache } from './utils/updateBookmarksCache';
import { SaveProps } from './props';
import './styles.scss';

export const Save: FC<SaveProps> = ({ user }) => {
  const dispatch = useAppDispatch();

  const [isBookmarked, setIsBookmarked] = useState(user.hasBookmarked);

  const [saveBookmark] = useSaveBookmarkMutation({
    onError: () => {
      dispatch(setErrorFlashMessage('Could not manage to save changes'));
    },
    update: (cache, { data }) => {
      if (data) {
        addBookmarkToCache(cache, data.saveBookmark);
      }
    },
  });

  const [removeBookmark] = useRemoveBookmarkMutation({
    onError: () => {
      dispatch(setErrorFlashMessage('Could not manage to save changes'));
    },
    update: cache => removeBookmarkFromCache(cache, user.id),
  });

  function onSaveClick(event: MouseEvent<HTMLElement>) {
    event.stopPropagation();

    setIsBookmarked(!isBookmarked);

    const variables = {
      entityId: user.id,
      type: BookmarkTypeEnum.USER,
    };

    trackEvent({
      context: MetricContext.SOURCE,
      interaction: user.hasBookmarked ? MetricAction.REMOVE_SAVED_VERIFIED_TALENT : MetricAction.SAVE_VERIFIED_TALENT,
      payload: {
        'User Id': user.id,
      },
    });

    if (user.hasBookmarked) {
      removeBookmark({ variables });
    } else {
      saveBookmark({ variables });
    }
  }

  return (
    <div
      className={classnames('talent-feed-item-save', isBookmarked && 'talent-feed-item-save--active')}
      onClick={onSaveClick}
    >
      <Svg className="talent-feed-item-save__icon" src={frHeartSvg} />
      <span>{user.hasBookmarked ? 'Saved' : 'Save'}</span>
    </div>
  );
};
